import { Route as ReactRoute, Redirect, useLocation } from 'react-router-dom'
import axios from 'axios'

/**
 * Public - open to all authenticated/unauthenticated, set open to true
 * PublicOnly - open to unauthenticated only, set auth to false
 * Private - open to authenticated only, set auth to true
 */
const Route = ({ auth = false, open = false, Component, ...props }) => {
  const location = useLocation()

  const token = window.localStorage.getItem('token')
  if (!!token) axios.defaults.headers.common['Authorization'] = token

  const authorized = (auth && token) || (!auth && !token) || open

  const isPrivateAndUnauthorized = auth && !token
  const privateRedirectPath = '/'

  const isPublicOnlyAndAuthorized = !auth && token
  const publicOnlyRedirectPath = '/courses'

  const sourceLocation = location.search && location.search.split('=')
  const hasSourceLocation = sourceLocation && sourceLocation.length === 2
  const sourcePath =
    hasSourceLocation && sourceLocation[1].replace(window.location.origin, '')

  const renderComponent = (routeProps) => {
    return <Component {...routeProps} />
  }

  const renderRedirect = (redirectPath, { location }) => (
    <Redirect
      exact
      to={{
        pathname: redirectPath,
        state: { from: location },
      }}
    />
  )

  return (
    <ReactRoute
      {...props}
      render={(renderProps) =>
        authorized
          ? renderComponent(renderProps)
          : isPrivateAndUnauthorized
          ? renderRedirect(privateRedirectPath, renderProps)
          : isPublicOnlyAndAuthorized && hasSourceLocation
          ? renderRedirect(sourcePath, renderProps)
          : renderRedirect(publicOnlyRedirectPath, renderProps)
      }
    />
  )
}

export { Route }
